"use client"; // Add this directive to make it a Client Component

import Link from 'next/link';
import Image from 'next/image';
import { useEffect } from 'react';
import styles from './not-found.module.css';

// We can't export metadata from a Client Component, so we'll handle this differently
// by setting the title and description programmatically
export default function NotFound() {
  useEffect(() => {
    // Update document title when component mounts
    document.title = 'Page Not Found | BEMOI';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'The page you are looking for could not be found. Explore the website to discover digital marketing insights and expertise.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'The page you are looking for could not be found. Explore the website to discover digital marketing insights and expertise.';
      document.head.appendChild(meta);
    }    // Add robots meta tag
    // Note: This should be handled by Next.js metadata API instead of manual manipulation
  }, []);

  return (
    <div className={styles.notFoundContainer}>
      <div className={styles.notFoundContent}>
        <h1 className={styles.notFoundTitle}>404</h1>
        <h2 className={styles.notFoundSubtitle}>Page Not Found</h2>
        <p className={styles.notFoundDescription}>
          Oops! The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        
        <div className={styles.notFoundSuggestions}>
          <h3>You might be interested in:</h3>
          <ul className={styles.suggestionLinks}>
            <li>
              <Link href="/" className={styles.suggestionLink}>
                Home Page
              </Link>
            </li>
            <li>
              <Link href="/experience" className={styles.suggestionLink}>
                Professional Experience
              </Link>
            </li>
            <li>
              <Link href="/experience#brands" className={styles.suggestionLink}>
                Brands I&apos;ve Worked With
              </Link>
            </li>
            <li>
              <Link href="/tech-stack" className={styles.suggestionLink}>
                Tech Stack & Skills
              </Link>
            </li>
            <li>
              <Link href="/articles" className={styles.suggestionLink}>
                Articles & Insights
              </Link>
            </li>
          </ul>
        </div>
        
        <Link href="/" className={styles.backHomeButton}>
          Back to Home
        </Link>
      </div>
      
      <div className={styles.notFoundImage}>
        <Image
          src="/404-illustration.svg"
          alt="Page not found illustration"
          width={400}
          height={400}
          priority
        />
      </div>
    </div>
  );
}